export default "/fonts/vendor/mdui/dist/roboto/Roboto-Thin.woff?9b3e35eb0a402cc52306ca1cdcbb3786";